// extracted by mini-css-extract-plugin
export default {"root":"PlasmicEmail1_root__BqGeN","rootdanger":"PlasmicEmail1_rootdanger__WJXym"};